import { render, staticRenderFns } from "./b-menu-drop-area.vue?vue&type=template&id=60db6b60&scoped=true&"
import script from "./b-menu-drop-area.vue?vue&type=script&lang=js&"
export * from "./b-menu-drop-area.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-drop-area.vue?vue&type=style&index=0&id=60db6b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db6b60",
  null
  
)

export default component.exports